module.exports = __webpack_public_path__ + "static/condo-6-38b1059cbb9bb69146d7825154866bf7.jpg";